import React, { useContext, useEffect, useState } from 'react';
import { handleResponse, numberWithCommas } from '../../../../../../Helper';
import { deviceAdminApi } from '../../../../../../api';
import { SelectOptions } from '../../../../../../model/CommonModel';
import { SelectTimeZone } from '../../../../../../model/DeviceAdminModel';
import { Select } from '../../../../../common/Select/Select';
import { setHardwarePermissionsAction } from '../../RoleContext/action';
import { RoleStore } from '../../RoleContext/context';
import styles from './timeZone.module.scss';

type Props = {
	selectedItemsInRoles: number;
};

const TimeZone: React.FC<Props> = ({ selectedItemsInRoles }) => {
	const {
		roleContextInitialState: { hardwarePermissions },
		dispatcher,
	} = useContext(RoleStore);
	const [timeZones, setTimeZones] = useState<SelectOptions<string>[]>([]);

	useEffect(() => {
		deviceAdminApi.getGenericTimeZonesUnfiltered().then(res => {
			if (!handleResponse(res)) {
				const { Entity: tZones } = res;
				const mappedTimeZones = mapTimeZones(tZones);
				setTimeZones(mappedTimeZones);
			}
		});
	}, []);

	const mapTimeZones = (timeZones: SelectTimeZone[]) => {
		return timeZones.map<SelectOptions<string>>(tz => ({
			key: tz.GenericId,
			id: tz.GenericId.toString(),
			value: tz.GenericId.toString(),
			label: tz.Name,
		}));
	};

	const { globalTimeZoneId } = hardwarePermissions;

	return (
		<div className={styles.container}>
			<div>
				<label id='activeTimeZoneLabel' htmlFor='activeTimeZoneSelect' className={styles.activeTimeZoneLabel}>
					{_('ActiveTimeZoneForAllDevices')}
				</label>
				<Select
					id='activeTimeZoneSelect'
					value={globalTimeZoneId.toString()}
					options={timeZones}
					className={styles.timeZones}
					onChange={(e: string) => {
						const id: number = isNaN(parseInt(e)) ? 0 : parseInt(e);
						dispatcher(setHardwarePermissionsAction({ ...hardwarePermissions, globalTimeZoneId: id, isDirty: true }));
					}}
					showSearch
				/>
			</div>
			<span className={styles.devicesSelected}>
				<strong>
					{numberWithCommas(selectedItemsInRoles)} {_('DevicesSelectedForRole')}
				</strong>
			</span>
		</div>
	);
};

export { TimeZone };
